const TEXTS: string[] = [
	`Более 5 лет занимаюсь разработкой интерфейсов разной сложности и предназначения.
	Специализируюсь на frontend-разработке для высоконагруженных продуктов: проектирую архитектуру, довожу решения от идеи до продакшена и отвечаю за стабильную поставку изменений.
	Основной стек — JavaScript/TypeScript, React и экосистема современных инструментов frontend-разработки.`,
	`Имею опыт промышленной разработки в финтехе по банковским стандартам безопасности и качества.
	Фокусируюсь на производительности, надежности клиентских приложений и предсказуемости релизов: от API-контрактов и интеграций до автоматизированных проверок в процессе разработки.`,
	`Сильные стороны: ownership, системное мышление и кросс-командное взаимодействие.
	Провожу code review, менторю коллег, участвую в архитектурных решениях и развиваю инженерные практики команды.
	Выступаю на профессиональных конференциях и делюсь опытом с сообществом разработчиков.`,
]

export { TEXTS }
